import { useParams } from 'react-router';
import AppNavLink from '@/components/Router/AppNavLink';
import { AppRoutes, buildRoute } from '@/route/routeConfig';

type NavPath = 'application_details' | 'due_diligence';

const navPathToRouteKey: Record<NavPath, AppRoutes> = {
  application_details: AppRoutes.ROVER_APPLICATION_FORM_APPLICATION_DETAIL,
  due_diligence: AppRoutes.ROVER_APPLICATION_FORM_APPLICATION_DUE_DILIGENCE,
};

const ApplicationDetailsNav = () => {
  const { applicationId, applicationFormId } = useParams<string>();
  const applicationDetailNavItems: { name: string; path: NavPath }[] = [
    { name: 'Application Details', path: 'application_details' },
    { name: 'Due Diligence', path: 'due_diligence' },
  ];

  const handleNavLink = (path: NavPath) => {
    if (!applicationFormId || !applicationId) {
      return '';
    }

    return buildRoute(navPathToRouteKey[path], {
      applicationFormId,
      applicationId,
    });
  };

  return (
    <div className='border-b-2 border-neutralColor-light flex gap-8 my-5 cursor-pointer'>
      {applicationDetailNavItems.map((item) => (
        <AppNavLink
          key={item.path}
          to={handleNavLink(item.path)}
          baseClassName='px-2 font-semibold'
          activeClassName='border-primaryColor-normal text-primaryColor-normal border-b-2 pb-2 -mb-0.5'
        >
          {item.name}
        </AppNavLink>
      ))}
    </div>
  );
};

export default ApplicationDetailsNav;
